<template>
  <div
    v-if="hasDeployInfo && !isClosed"
    data-testid="deployed-branch-badge"
    class="deployed-branch"
    :class="{
      'deployed-branch--expanded': isExpanded,
    }"
  >
    <div
      class="deployed-branch__header"
      role="button"
      tabindex="0"
      @click="onClickToggle"
      @keydown.enter.prevent="onClickToggle"
      @keydown.space.prevent="onClickToggle"
    >
      🚀

      <span
        v-if="!isExpanded"
        class="deployed-branch__header-collapsed"
      >
        deploy: {{ branch }}
      </span>

      <span
        v-if="isExpanded"
        class="deployed-branch__header-expanded"
      >
        <a
          v-if="url"
          :href="url"
          target="_blank"
          rel="noopener noreferrer"
          @click.stop
        >
          PR #{{ number }}
        </a>

        <span
          v-if="!url"
        >
          {{ branch }}
        </span>
      </span>

      <button
        type="button"
        data-testid="btn-close-deployed-branch-badge"
        class="deployed-branch__close"
        @click.stop="onClickClose"
      >
        ×
      </button>
    </div>

    <div
      v-if="isExpanded"
      class="deployed-branch__content"
    >
      <div
        class="deployed-branch__branch"
      >
        {{ branch }}
      </div>

      <div
        class="deployed-branch__title"
      >
        {{ title }}
      </div>

      <pre
        v-if="body"
        class="deployed-branch__body"
      >{{ body }}</pre>
    </div>
  </div>
</template>

<script>
import deployedPrInfo from '@/config/deployed-pr-info.json'

export default {
  name: 'BannerDeployedBranch',

  data () {
    return {
      number: deployedPrInfo.number,
      title: deployedPrInfo.title,
      body: deployedPrInfo.body,
      branch: deployedPrInfo.branch,
      url: deployedPrInfo.url,
      isExpanded: false,
      isClosed: false,
    }
  },

  computed: {
    hasDeployInfo () {
      return Boolean(this.title) || Boolean(this.branch)
    },
  },

  methods: {
    onClickToggle () {
      this.isExpanded = !this.isExpanded
    },

    onClickClose () {
      this.isClosed = true
    },
  },
}
</script>

<style
  scoped
  lang="scss"
>
.deployed-branch {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10000;
  max-width: 90vw;
  background-color: #eee;
  border-top: 1px solid #777;
  border-right: 1px solid #777;
  border-top-right-radius: 0.5rem;
  font-size: 0.8rem;

  &--expanded {
    width: 360px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 0.25rem 0.5rem;
    font-weight: bold;
    cursor: pointer;
    white-space: nowrap;
  }

  &__header-collapsed {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__close {
    margin-left: auto;
    padding: 0 4px;
    border: 0;
    background: none;
    font-size: 1.1rem;
    line-height: 1;
    color: #777;
    cursor: pointer;

    &:hover {
      color: #000;
    }
  }

  &__content {
    border-top: 1px solid #999;
    padding: 0.5rem;
  }

  &__branch {
    font-family: monospace;
    color: #555;
  }

  &__title {
    margin-top: 2px;
    font-weight: bold;
  }

  &__body {
    margin: 8px 0 0;
    padding-top: 8px;
    border-top: 1px solid #ccc;
    max-height: 50vh;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: inherit;
    font-size: 0.75rem;
    color: #333;
  }
}
</style>
